<template>
  <v-list-item class="mt-2">
    <v-list-item-content class="pa-5">
      <h4 class="font-weight-light">{{ item.name }}</h4>

      <h5 v-if="item.discount" class="red--text text--lighten-2 font-weight-bold peso"><span v-html="MIXIN_PESO_SIGN"></span>{{ item.discount }} OFF</h5>

      <v-row align="center">
        <v-col cols="3">
          <slot name="decrease-button"></slot>
        </v-col>
        <v-col cols="6">
          <v-text-field
            style="text-align:center"
            v-model="quantity"
            outlined
            dense
            type="number"
            :readonly="readOnlyQuantity"
            @keyup="delayChangeQuantity"
            :rules="mustBeGreaterThanOneRule"
            min="1"
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <slot name="increase-button"></slot>
        </v-col>
      </v-row>

      <v-row no-gutters align="center">
        <v-col cols="9">
          <h3>
            <span class="peso" v-html="MIXIN_PESO_SIGN"></span>
            <span>{{ item.price | numFormat }}</span>
            <span class="label">{{ item.price | numFormat('.00') }}/YR</span>
          </h3>
        </v-col>
        <v-col cols="3">
          <slot name="delete-item"></slot>
        </v-col>
      </v-row>

      <v-row no-gutters align="center">
        <v-col>
          <slot name="cart-message"></slot>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  export default {
    name: "CartItem",
    data: () => ({
      //
      mustBeGreaterThanOneRule: [v => {
        if (!isNaN(parseInt(v)) && v >= 1) return true;
        return 'This field must be greater than zero';
      }],
    }),
    props: {
      readOnlyQuantity: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      item: function() {
        if (this.$route.name == 'Shop' || this.$route.name == 'Home')
          return this.$store.getters['cart/item']
        else if (this.$route.name == 'ShopMerchant')
          return this.$store.getters['merchantCart/item']
        else
          return this.$store.getters['promoCart/item']
      },
      quantity: {
        get() {
          if (this.$route.name == 'Shop' || this.$route.name == 'Home')
            return this.$store.getters['cart/quantity']
          else if (this.$route.name == 'ShopMerchant')
            return this.$store.getters['merchantCart/quantity']
          else
            return this.$store.getters['promoCart/quantity']
        },
        set(val) {
          if (this.$route.name == 'Shop' || this.$route.name == 'Home') {
            // if (val > 100)
            //   this.$store.commit('cart/setQuantity', 100)
            // else
            if (val <= 0){
              this.$store.commit('cart/setQuantity', 1)
            } else {
              this.$store.commit('cart/setQuantity', val)
            }
          }
          else if (this.$route.name == 'ShopMerchant') {
            // if (val > 100)
            //   this.$store.commit('merchantCart/setQuantity', 100)
            // else
            if (val <= 0){
              this.$store.commit('merchantCart/setQuantity', 1)
            } else {
              this.$store.commit('merchantCart/setQuantity', val)
            }
          }
          else {
            // if (val > 100)
            //   this.$store.commit('promoCart/setQuantity', 100)
            // else
            if (val <= 0){
              this.$store.commit('promoCart/setQuantity', 1)
            } else {
              this.$store.commit('promoCart/setQuantity', val)
            }
          }
        }
      }
    },
    mounted() {
      //
    },
    methods: {
      changeQuantity() {
        console.log('change', this.quantity)
      },
      delayChangeQuantity() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.changeQuantity();
        }, 500);
      }
    }
  }
</script>

<style lang="scss" scoped>
.peso {
	font-family: Arial;
}

.label {
	font-size: 14px;
}
</style>